<template>
    <div>
        <div
            class="white-box"
            :class="{'white-box-no-tab':$route.meta.code==='BD' }"
        >
            <Title
                v-if="$route.meta.code=='BD'"
                :text="$route.meta.pageTitle"
                style-code-page
            />
            <h4 class="mb-3 md:mb-3.5">
                保全聯盟鏈
            </h4>
            <p class="text-lg">
                您本次辦理的變更內容有符合可申請轉送至其他保險公司之項目，請問您是否同意申請轉送？<br>
                (可轉送變更項目：要保人住所地址/電話、收費地址/電話、要保人行動電話/E-mail)
            </p>
            <div class="flex mb-4">
                <Radio
                    v-model:checked-value="isAgreeNotify"
                    value="Y"
                    name="agree"
                    text="同意"
                    class="pr-5 mb-1.5 md:m-0"
                    @click="popupDialog"
                />
                <Radio
                    v-model:checked-value="isAgreeNotify"
                    value="N"
                    name="agree"
                    text="不同意"
                    class="pr-5 mb-1.5 md:m-0"
                    @click="closeDialog"
                />
            </div>
            <transition name="showPageTransition">
                <FormList
                    v-if="showAllianceForm"
                    v-model:isFormReady="isFormReady"
                    v-model:requestBody="requestBody"
                    :is-agree-notify="isAgreeNotify"
                    :term="term"
                    :title="title"
                    :companies="companies"
                    :pupConfirm="pupConfirm"
                />
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="!btnDisabled"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
        <PopupLiaCompany
            v-if="isAgreeNotify==='Y'"
            v-model:visiblePopup="visiblePopup"
            v-model:showAllianceForm="showAllianceForm"
            v-model:pupConfirm="pupConfirm"
        />
    </div>
</template>
<script>
import { ref, computed, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Bottombar from '@/components/layout/Bottombar.vue';
import FormList from './Form.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Title from '@/components/text/Title.vue';
import { getAgreeTermsBCBD, getAllianceChain, submitAllianceChain } from '@/apis/BCBD';
import Radio from '@/components/radios/Radio.vue';
import Loading from '@/components/Loading.vue';
import PopupLiaCompany from '@/components/dialogs/PopupLiaCompany.vue';
import _ from 'lodash';

export default {
    components: {
        PopupLiaCompany,
        Bottombar,
        FormList,
        Title,
        Radio,
        Loading,
        ButtonNextService
    },
    setup() {
        const pupConfirm = ref(false);
        const showAllianceForm = ref(false);
        const visiblePopup = ref(false);
        const route = useRoute();
        const isFormReady = ref(false);
        const isAgreeNotify = ref('');
        const store = useStore();
        const isLoading = ref(false);
        const { code } = route.meta;
        const isSubmitOk = ref(false);
        const requestBody = ref({});
        const companies = reactive({
            lifeCompany: [],
            propertyCompany: [],
            liaStatus: '',
        });
        const result = computed(() => store.state.services.changeItemsResult[code]);
        const term = ref('');
        const title = ref('');
        getAgreeTermsBCBD(code).then(res => {
            title.value = res.data.agreeTerms.title;
            term.value = res.data.agreeTerms.content;
        });
        const getCompanies = () => {
            getAllianceChain(code).then(res => {
                const { lifeCompany, propertyCompany, liaStatus } = res.data;
                companies.lifeCompany = lifeCompany;
                companies.propertyCompany = propertyCompany;
                companies.liaStatus = liaStatus;
                store.dispatch('services/setChangeItemsResult', { code, value: companies });
            });
        };

        if (!result.value) {
            getCompanies();
        } else {
            const { lifeCompany, propertyCompany, liaStatus } = result.value;
            companies.lifeCompany = lifeCompany;
            companies.propertyCompany = propertyCompany;
            companies.liaStatus = liaStatus;
        }

        const saveAndgoNext = () => {
            isLoading.value = true;
            store.dispatch('services/setChangeItemsResult', { code, value: companies });
            const data = isFormReady.value && isAgreeNotify.value === 'Y'
                ? requestBody.value : { agree: false, agreeAllianceChainInfo: false, lifeCheck: [], propertyCheck: [] };
            submitAllianceChain(code, data).then(() => {
                isSubmitOk.value = true;
            }).finally(() => {
                isLoading.value = false;
            });
        };

        const btnDisabled = computed(() => {
            return isAgreeNotify.value === 'N' || isFormReady.value;
        });

        const popupDialog = () => {
            if (visiblePopup.value) {
                return;
            }
            visiblePopup.value = true;
        };

        const closeDialog = () => {
            visiblePopup.value = true;
            showAllianceForm.value = false;
        };

        watch(() => pupConfirm.value, (newV) => {
            if (newV) {
                const { lifeCompany, propertyCompany, liaStatus } = result.value;
                companies.lifeCompany = lifeCompany;
                companies.propertyCompany = propertyCompany;
                companies.liaStatus = liaStatus;
            } else {
                const { lifeCompany, propertyCompany, liaStatus } = result.value;
                const _lifeCompany = _.cloneDeep(lifeCompany);
                const _propertyCompany = _.cloneDeep(propertyCompany);
                _lifeCompany.forEach((p) => {
                    p.existLai = false;
                });
                _propertyCompany.forEach((p) => {
                    p.existLai = false;
                });
                companies.lifeCompany = _lifeCompany;
                companies.propertyCompany = _propertyCompany;
                companies.liaStatus = liaStatus;
                store.dispatch('services/setChangeItemsResult', { code, value: companies });
            }
        }, { immediate: false, deep: true });

        return {
            pupConfirm,
            showAllianceForm,
            term,
            title,
            companies,
            visiblePopup,
            saveAndgoNext,
            popupDialog,
            closeDialog,
            isFormReady,
            isAgreeNotify,
            btnDisabled,
            isSubmitOk,
            requestBody,
            isLoading
        };
    },
};
</script>
<style lang="scss" scoped>
.showPageTransition-enter-active {
    animation: toolbar-in 0.3s;
}
.showPageTransition-leave-active {
    animation: toolbar-in 0.3s reverse;
}
@keyframes toolbar-in {
    0% {
        opacity: 0;
        transform: translateY(50%);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
